<template>
  <div
    class="mask-box"
    v-if="isShow"
    @touchmove.prevent
  >
    <div class="mask"></div>
    <div class="content-box">
      <div class="close-btn" @click="handleClose">x</div>
      <SubscribeBox></SubscribeBox>
    </div>
  </div>
</template>
<script>
import SubscribeBox from "./subscribe-box";
export default {
  name: "SubscribeMask",
  components: { SubscribeBox },
  props: {
    isShow: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    handleClose() {
      console.log(123);
      this.$emit("update:isShow", false);
    },
  },
};
</script>
<style scoped>
.mask-box {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  z-index: 1000;
}
.mask {
  height: 100%;
  width: 100%;
  opacity: 0.5;
  background-color: rgba(51, 51, 51, 100);
}
.content-box {
  position: absolute;
  top: calc(50vh - 95px);
  left: calc(50vw - 125px);
}
.close-btn {
  width: 22px;
  height: 22px;
  background-color: rgba(250, 250, 250, 100);
  border-radius: 11px;
  font-size: 18px;
  line-height: 20px;
  position: absolute;
  right: -22px;
  top: -24px;
}
</style>


// WEBPACK FOOTER //
// src/components/subscribe-mask.vue